import { render } from "./Profile-forum.vue?vue&type=template&id=58bdf6c1"
import script from "./Profile-forum.vue?vue&type=script&lang=js"
export * from "./Profile-forum.vue?vue&type=script&lang=js"

import exportComponent from "E:\\D\\web\\pyCharm\\arhichat-3.4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__